import React, { useEffect, useRef, useState } from "react";
import { TextField, InputLabel, MenuItem } from "@mui/material";
import { TbPhotoPlus } from "react-icons/tb";
import { FaAngleLeft } from "react-icons/fa";
import { Button, message } from "antd";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  categoryImagePost,
  post_category,
  updateImages,
  validateSlugUrl,
} from "../../../redux/Category/CategorySlice";
import { LineWave } from "react-loader-spinner";

const AddCategory = () => {
  const dispatch = useDispatch();

  const { mobileImage, desktopImage, categoryImageLoading } = useSelector(
    (store) => store.category
  );

  const [categoryName, setCategoryName] = useState("");
  const [categoryUrl, setCategoryUrl] = useState("");
  const [categoryError, setCategoryError] = useState("");
  const [imageError, setimageError] = useState("");
  const [button_press, setButton_press] = useState(false);

  const [messageApi, contextHolder] = message.useMessage();

  const fileInputRef = useRef(null);

  const check_category_url = async (e) => {
    const value = e.target.value.replace(/\b\w/g, (char) => char.toUpperCase());
    setCategoryName(value);
    setCategoryError("");
    if (value) {
      const url = value
        .trim()
        .toLowerCase()
        .replace(" ", "-")
        .replace(/[.*+&?^ $@#%^!'{}()|[\]\\]/g, "-")
        .replace("--", "-")
        .replace("---", "-")
        .replace("----", "-")
        .replace("/", "-")
        .replace("//", "-")
        .replace("///", "-");

      const verify = await dispatch(validateSlugUrl(url));
      if (verify.payload.success === false) {
        setCategoryUrl(url);
        setCategoryError("");
      } else {
        setCategoryUrl("");
        setCategoryError(verify.payload.message);
      }
    }
  };

  const handleImageClick = () => {
    fileInputRef.current.click();
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const files = Array.from(e.target.files);
      files.forEach((file) => {
        const reader = new FileReader();
        reader.onload = () => {
          if (reader.readyState === 2) {
            dispatch(categoryImagePost({ desktopImage: reader.result }));
          }
        };
        reader.readAsDataURL(file);
      });
    }
  };

  useEffect(() => {
    if (button_press === true) {
      if (categoryUrl === "") {
        setCategoryError("Enter name");
      } else {
        setCategoryError("");
      }
      if (mobileImage === "") {
        setimageError("Uploade Image");
      } else {
        setimageError("");
      }
    }
  }, [button_press, categoryUrl, mobileImage]);

  const submitPress = async () => {
    setButton_press(true);
    if (categoryUrl !== "" && desktopImage !== "") {
      const formdata = {
        name: categoryName,
        slugUrl: categoryUrl,
        mobileImage: mobileImage,
        desktopImage: desktopImage,
        metaTitle: categoryName,
        metaKeyword: categoryName,
        metaDesc: categoryName,
      };
      const form_posting = await dispatch(post_category(formdata));
      if (form_posting.payload.success === true) {
        messageApi.open({
          type: "success",
          content: `Category add Successfully`,
        });
        const formdata = {
          mobileimages: "",
          desktopImages: "",
        };
        dispatch(updateImages(formdata));
        setCategoryName("");
        setCategoryUrl("");
        setCategoryError("");
        setButton_press(false);
      }
    }
  };

  const input_lable_style = {
    color: "#1a1a1a",
    fontSize: "0.75rem",
    fontWeight: "800",
    marginBottom: "0.5vh",
    textTransform: "uppercase",
  };
  return (
    <>
      {contextHolder}
      <div className="add_page_main">
        <div className="add_hedaer_main_cnf">
          <div className="add_page_header">
            <h4>Add New Category</h4>
            <Link to="/admin/list-category">
              <div className="bac_add_nav">
                <span>
                  <FaAngleLeft color="#333333" />
                </span>
                <h6>Category List</h6>
              </div>
            </Link>
          </div>
        </div>
        <div className="add_input_box_main">
          <div className="add_page">
            <div className="input_container">
              <div className="input_box_container">
                <InputLabel sx={input_lable_style} htmlFor="custom-input">
                  Name
                </InputLabel>
                <TextField
                  id="custom-input"
                  placeholder="Enter text here"
                  variant="outlined"
                  error={categoryError !== "" ? true : false}
                  helperText={categoryError}
                  autocomplete="off"
                  size="small"
                  className="input_container"
                  onChange={(e) => check_category_url(e)}
                  value={categoryName}
                  InputProps={{
                    style:
                      categoryError !== ""
                        ? {
                            backgroundColor: "#ffe6e6",
                            border: "1px solid red",
                          }
                        : {},
                  }}
                  FormHelperTextProps={{
                    style: {
                      marginTop: "0vh",
                    },
                  }}
                />
              </div>
              <div className="input_box_container">
                <InputLabel sx={input_lable_style} htmlFor="custom-input">
                  Image
                </InputLabel>
                {!desktopImage ? (
                  <>
                    {/* {categoryImageLoading === true ? (
                      <></>
                    ) : (
                      <>
                        <div className="imageref_box">
                          <LineWave
                            visible={true}
                            height="100"
                            width="100"
                            color="#4fa94d"
                            ariaLabel="line-wave-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                            firstLineColor=""
                            middleLineColor=""
                            lastLineColor=""
                          />
                        </div>
                      </>
                    )} */}
                    <div
                      className={
                        desktopImage === "" && button_press === true
                          ? "imageref_box image_error_input"
                          : "imageref_box"
                      }
                      onClick={handleImageClick}
                    >
                      <TbPhotoPlus size={28} color="#999999" />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="imageref_box" onClick={handleImageClick}>
                      <img src={desktopImage} alt="img" />
                    </div>
                  </>
                )}

                <span className="sub_text_title">Aspect Ratio - 4:3</span>
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
              </div>

              <div className="submit_btn_container">
                <Button
                  className="confirm_btn sub_padding"
                  onClick={() => submitPress()}
                >
                  Submit
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCategory;
